var _style, _ellipse, _circle, _ellipse2, _circle2, _ellipse3, _circle3, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVissightsLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 261.1 237.4",
    style: {
      enableBackground: "new 0 0 261.1 237.4"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#F39200;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#1D71B8;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke: #f39200;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#1D71B8;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#F39200;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#1D71B8;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -8.901061e-03 8.901061e-03 1 -0.3361 1.0995)",
    className: "st0",
    cx: 123.4,
    cy: 38.3,
    rx: 29.2,
    ry: 29.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 123.4,
    cy: 38.8,
    r: 18.9
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 82,
    cy: 156.2,
    rx: 73.1,
    ry: 74.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 82,
    cy: 156.2,
    r: 57.8
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 208.6,
    cy: 92,
    rx: 43.8,
    ry: 44.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 208.6,
    cy: 91.4,
    r: 33.1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 149.1,
    y1: 119.7,
    x2: 168.1,
    y2: 109
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 149.7,
    y1: 53.4,
    x2: 170,
    y2: 64.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVissightsLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vissights-logo.f17d957bf72efbb388b857ec080fbf37.svg";